import Route from './Route';
import Error404 from '../views/errors/404';
import Login from '../views/auth/Login';
import ForgotPassword from '../views/auth/ForgotPassword';
import ResetPassword from '../views/auth/ResetPassword';
import MasterLayout from '../views/layouts/MasterLayout';
import SectionLayout from '../views/layouts/SectionLayout';
import ClientLayout from '../views/layouts/ClientLayout';
import GroupLayout from '../views/layouts/GroupLayout';
import DeviceLayout from '../views/layouts/DeviceLayout';
import Dashboard from '../views/Dashboard';
import auth from './middleware/auth';
import guest from './middleware/guest';
import AccountSettings from '../views/AccountSettings';
import DeviceModule from './Devices/ChildRoutes/DeviceModule';
import GroupRoot from './Groups/ChildRoutes/Root';
import ConnectionView from './Connections/ChildRoutes/ConnectionView';
import ClientMagTemplates from './Clients/ChildRoutes/MagTemplate';
import MagTemplateRoutes from './MagTemplates';

export default [
	Route.get('/login', Login).name('login').middleware([ guest ]),
	Route.get('/password').redirect('/login'),
	Route.get('/password/forgot', ForgotPassword).name('forgot-password').middleware([ guest ]),
	Route.get('/password/reset', ResetPassword).name('reset-password').middleware([ guest ]),

	Route.group('/', MasterLayout, [
		Route.get('/', Dashboard).name('dashboard').meta('static', false),
		Route.get('/account-settings', AccountSettings).name('account_settings').meta('static', false),
		Route.get('clients', () => import('../views/Clients')).name('clients').meta('static', false),
		Route.get('connections', () => import('../views/Connections')).name('connections'),
		Route.get('translator-servers', () => import('../views/TranslatorServers')).name('translator-servers'),
		Route.get('search', () => import('../views/GlobalSearch')).name('search'),
		Route.get('users', () => import('../views/Users')).name('users'),
		// Route.get('connections/:id(\\d+)', () => import('../views/connections/ConnectionView')).name('connection-view'),
		ConnectionView,
		Route.get('monitor-errors', () => import('../views/MonitorErrors')).name('cw-monitor-errors'),
		Route.get('roles', () => import('../views/Roles')).name('roles'),
		MagTemplateRoutes,
		Route.group('clients/:id(\\d+)', SectionLayout, [
			Route.group('/', ClientLayout, [
				Route.get('/', () => import('../views/client/ClientDashboard')).name('client'),
				Route.get('search', () => import('../views/GlobalSearch')).name('client-search'),
				Route.get('notifications', () => import('../views/client/ClientNotifications')).name('client-notifications'),
				Route.get('monitors', () => import('../views/client/ClientMonitors')).name('client-monitors'),
				Route.get('groups', () => import('../views/client/ClientGroups')).name('client-groups'),
				Route.get('cw-settings', () => import('../views/client/CwSettings')).name('client-cw-settings'),
				ClientMagTemplates
			]),
			Route.get('groups/unassigned/:type?', () => import('../views/group/Unassigned')).name('group-unassigned'),
			Route.group('groups/:groupId(\\d+)', GroupLayout, [
				GroupRoot,
				Route.get('metrics', () => import('../views/group/GroupDashboard')).name('group-metrics'),
				Route.get('devices', () => import('../views/group/GroupDevices')).name('group-devices'),
				Route.get('monitors', () => import('../views/group/GroupMonitors')).name('group-monitors'),
				Route.get('notifications', () => import('../views/group/GroupNotifications')).name('group-notifications')
			]),
			Route.group('groups/:groupId(\\d+)/devices/:deviceId(\\d+)', DeviceLayout, [
				// TODO: Setup proper URL schema for device categories
				Route.get('/', () => import('../views/device/Dashboard')).name('device'),
				Route.get(':categoryId(\\d+)', () => import('../views/device/Category')).name('device-category'),
				Route.get('monitors', () => import('../views/device/Monitors')).name('device-monitors'),
				Route.get('notifications', () => import('../views/device/Notifications')).name('device-notifications'),
				Route.get('additional-info', () => import('../views/device/AdditionalInfo')).name('device-info'),
				Route.get('child-devices/:typeId(\\d+)', () => import('../views/device/ChildDevices')).name('child-device'),
				DeviceModule
			])
			// Route.get('devices/:typeId(\\d+)/:deviceId(\\d+)', () => import('../views/group/Device')).name('device'),
		]).meta({
			collapse: true,
			static: false
		})
	]).middleware([ auth ]),
	// 404 Route
	Route.get('*', Error404)
];
